import { render, staticRenderFns } from "./ImpressumPage.vue?vue&type=template&id=1019e85c&scoped=true&"
import script from "./ImpressumPage.vue?vue&type=script&lang=js&"
export * from "./ImpressumPage.vue?vue&type=script&lang=js&"
import style0 from "./ImpressumPage.vue?vue&type=style&index=0&id=1019e85c&prod&lang=scss&scoped=true&"
import style1 from "./ImpressumPage.vue?vue&type=style&index=1&id=1019e85c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019e85c",
  null
  
)

export default component.exports